import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { I18n } from 'react-redux-i18n'
import { Collapse } from 'reactstrap'
import { toast } from 'react-toastify'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import _ from 'lodash'

import './styles.scss'
import { company } from 'api'
import { poolsActions } from 'redux/actions'
import poolLists from 'redux/poolLists/actions'
// import { success } from 'redux/actions/conversations/user'
import operatorActions from 'redux/actions/user'
import ScrollableContent from '../../ScrollableContent'
import SideMenuFilters from '../SideMenuFilters'
import PoolFoldersItem from './PoolFoldersItem'

const SidemenuPoolFolders = props => {
  const { selectTypeOptions, channelsOptions } = props
  const { tabs, poolLists: poolListsState, user: powerUser, pools } = useSelector(store => store)
  const { lists: listsState, collapse, poolListOrder } = poolListsState
  const [lists, setLists] = useState([])
  const history = useHistory()
  const dispatch = useDispatch()
  const ref = useRef()

  useEffect(() => {
    dispatch(poolLists.listsAndUsers({
      selectType: powerUser.frontOptions?.poolListSelectType,
      channels: powerUser.frontOptions?.poolListChannel?.length === channelsOptions.length ? [] : powerUser.frontOptions?.poolListChannel,
      brands: powerUser.frontOptions?.poolListBrandsAndDelegations?.brands || [],
      delegations: powerUser.frontOptions?.poolListBrandsAndDelegations?.delegations || []
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    powerUser.frontOptions.poolListSelectType,
    powerUser.frontOptions.poolListChannel,
    powerUser.frontOptions.poolListBrandsAndDelegations,
    pools.refreshCounter
  ])

  useEffect(() => {
    if (pools.refreshCounter) {
      dispatch(poolLists.listsAndUsers({
        selectType: powerUser.frontOptions?.poolListSelectType,
        channels: powerUser.frontOptions?.poolListChannel?.length === channelsOptions.length ? [] : powerUser.frontOptions?.poolListChannel,
        brands: powerUser.frontOptions?.poolListBrandsAndDelegations?.brands || [],
        delegations: powerUser.frontOptions?.poolListBrandsAndDelegations?.delegations || []
      }))
    }
    return () => dispatch(poolsActions.resetRefreshCounter())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pools.refreshCounter])

  useEffect(() => {
    if (listsState.length) {
      applySwitchs({
        poolListSort: powerUser.frontOptions?.poolListSort,
        poolListCheckedPendingMsg: powerUser.frontOptions?.poolListCheckedPendingMsg,
        poolListNotAssigned: powerUser.frontOptions?.poolListNotAssigned,
        poolListOutbound: powerUser.frontOptions?.poolListOutbound,
        poolListOrderByList: poolListOrder
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listsState])

  const applySwitchs = ({
    poolListSort,
    poolListCheckedPendingMsg,
    poolListNotAssigned,
    poolListOutbound,
    poolListOrderByList
  }) => {
    let _lists = _.cloneDeep(listsState)

    if (poolListSort === 'asc') {
      _lists.forEach(it => {
        it.users = it.users.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      })
    }
    if (poolListCheckedPendingMsg) {
      _lists.forEach(it => {
        it.users = it.users.filter(it2 => it2.isRead === false)
      })
    }
    if (poolListNotAssigned) {
      _lists.forEach(it => {
        it.users = it.users.filter(it2 => it2.assignedTo.length === 0)
      })
    }
    if (poolListOutbound) {
      _lists.forEach(it => {
        it.users = it.users.filter(it2 => it2.outbound === true)
      })
    }

    setLists(orderByList(_lists, poolListOrderByList))
  }

  const selectList = (listId) => {
    const _collapse = _.cloneDeep(collapse)
    const index = _collapse.indexOf(listId)

    if (index > -1) {
      _collapse.splice(index, 1)
    } else {
      _collapse.push(listId)
    }
    dispatch(poolLists.collapse(_collapse))
  }

  const selectUser = (user) => {
    history.push(`${history.location.pathname}?user_id=${user.id}`)
  }

  const unassignMe = (user) => {
    const assignedId = powerUser._id

    company.assignationsUsers
      .remove({
        userId: user.id,
        operator: { id: assignedId, company: user.company },
        operatorIds: [assignedId],
      })
      .then(({ data }) => {
        if (data.statusOk) {
          // dispatch(success(data.results))
          dispatch(poolLists.event())
          toast(I18n.t('dashboard_unassigned-conversation'), { position: 'top-center' })
        }
      })
      .catch(console.error)
  }

  const assignToMyself = (user) => {
    const assignedId = powerUser._id

    company.assignationsUsers
      .add({
        userId: user.id,
        operator: { id: assignedId, company: user.company },
        operatorIds: [assignedId],
      })
      .then(({ data }) => {
        if (data.statusOk) {
          // dispatch(success(data.results))
          dispatch(poolLists.event())
          toast(I18n.t('dashboard_assigned-conversation'), { position: 'top-center' })
        }
      })
      .catch(console.error)
  }

  const onDragEnd = (result) => {
    if (!result.destination) {
      return
    }
    let _listSource = result.draggableId
    const _poolListOrder = _.clone(poolListOrder)

    //REMUEVO EL ITEM QUE ARRASTRÉ
    _poolListOrder.splice(result.source.index, 1)

    //AGREGO EN DESTINO
    _poolListOrder.splice(result.destination.index, 0, _listSource)

    // REALIZO EL RENDER
    applySwitchs({
      poolListSort: powerUser.frontOptions.poolListSort,
      poolListCheckedPendingMsg: powerUser.frontOptions.poolListCheckedPendingMsg,
      poolListNotAssigned: powerUser.frontOptions.poolListNotAssigned,
      poolListOutbound: powerUser.frontOptions.poolListOutbound,
      poolListOrderByList: _poolListOrder
    })
    dispatch(poolLists.updateListOrder(_poolListOrder))

    //UPDATE DEL USUARIO
    dispatch(operatorActions.updateOperator({
      ...powerUser,
      frontOptions: {
        ...powerUser.frontOptions,
        poolListOrder: _poolListOrder
      }
    }))
  }

  const orderByList = (arrayRaw, listToOrder = []) => {
    const _listToOrder = _.clone(listToOrder)
    const arraySort = arrayRaw.map(item => {
      let n = _listToOrder.indexOf(item._id)
      if (n === -1)
        n = arrayRaw.length //COLOCA AL FINAL LOS QUE NO EXISTAN
      _listToOrder[n] = ''
      return [n, item]
    })

    return _.orderBy(arraySort, [0]).map(it => it[1])
  }

  return (
    <div className='animated fadeIn'>
      <div className='sidemenu-container'>
        <div className='users-toggle'>
          <SideMenuFilters
            key='switchSideMenuPoolFolders'
            options={{
              filter: {
                value: (powerUser.frontOptions?.poolListSort && powerUser.frontOptions.poolListSort !== 'desc' && true)
                  || powerUser.frontOptions?.poolListCheckedPendingMsg
                  || powerUser.frontOptions?.poolListNotAssigned
                  || powerUser.frontOptions?.poolListOutbound
                  || (powerUser.frontOptions?.poolListSelectType && powerUser.frontOptions.poolListSelectType.value !== 'all' && true)
                  || (powerUser.frontOptions?.poolListChannel && powerUser.frontOptions.poolListChannel.length && true)
                  || (powerUser.frontOptions?.poolListBrandsAndDelegations && (powerUser.frontOptions.poolListBrandsAndDelegations.brands?.length || powerUser.frontOptions.poolListBrandsAndDelegations.delegations?.length) && true)
                  || false,
                key: 'filter',
                keys: ['poolListSort', 'poolListCheckedPendingMsg', 'poolListNotAssigned', 'poolListOutbound', 'poolListSelectType', 'poolListChannel', 'poolListBrandsAndDelegations'],
                pool: 'poolLists',
                showTooltipOn: true,
                tooltip: I18n.t('conversations_tooltip_filter')
              },
              order: {
                key: 'poolListSort',
                value: powerUser.frontOptions?.poolListSort,
                tooltip: powerUser.frontOptions?.poolListSort === 'asc'
                  ? I18n.t('dashboard_order_asc')
                  : I18n.t('dashboard_order_desc')
              },
              notRead: {
                key: 'poolListCheckedPendingMsg',
                value: powerUser.frontOptions?.poolListCheckedPendingMsg,
                tooltip: I18n.t('conversations_tooltip_not_read'),
                showTooltipOn: false
              },
              notAssign: {
                key: 'poolListNotAssigned',
                value: powerUser.frontOptions?.poolListNotAssigned,
                tooltip: I18n.t('conversations_tooltip_not_assigned'),
                showTooltipOn: false
              },
              outbound: {
                key: 'poolListOutbound',
                value: powerUser.frontOptions?.poolListOutbound,
                tooltip: I18n.t('conversations_tooltip_outbound'),
                showTooltipOn: false
              },
              selectType: {
                key: 'poolListSelectType',
                value: powerUser.frontOptions?.poolListSelectType
              },
              selectTypeOptions,
              channels: {
                key: 'poolListChannel',
                value: powerUser.frontOptions?.poolListChannel
              },
              channelsOptions,
              brandsAndDelegations: {
                key: 'poolListBrandsAndDelegations',
                value: powerUser.frontOptions?.poolListBrandsAndDelegations
              }
            }}
            onChange={applySwitchs}
          />
        </div>
        <div>
          <ScrollableContent
            className='lists pool-lists-user-height'
            goToTop
          >
            <Collapse isOpen className='m-0 users' ref={ref}>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="listDroppable" type="COLUMN">
                  {(provided_list, snapshot_list) => (
                    <div
                      className='lists__container fadeIn animated'
                      ref={provided_list.innerRef}
                      {...provided_list.droppableProps}
                      style={{
                        minHeight: lists.length ? lists.length * 50 : 50,
                        backgroundColor: snapshot_list.isDraggingOver && '#e2e2e2'
                      }}
                    >
                      {lists.map((list, index) => (
                        <Draggable
                          key={`list-${list._id}`}
                          draggableId={list._id}
                          index={index}
                        >
                          {(provided_list2) => {
                            const isActive = collapse.indexOf(list._id) > -1
                            const listUsers = list.users
                            const listSize = listUsers.length

                            return (
                              <PoolFoldersItem
                                key={list._id}
                                id={list._id}
                                name={list.name}
                                color={list.color}
                                pendingMsgCount={list.pendingMsgCount}
                                users={list.users}
                                size={listSize}
                                isActive={isActive}
                                tabs={tabs}
                                powerUser={powerUser}
                                unassignMe={unassignMe}
                                assignToMyself={assignToMyself}
                                selectUser={selectUser}
                                selectList={selectList}
                                handleProps={provided_list2}
                              />
                            )
                          }}
                        </Draggable>
                      ))}
                      {provided_list.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </Collapse>
          </ScrollableContent>
        </div>
      </div>
    </div>
  )
}

export default SidemenuPoolFolders
